import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getNameEnquiry } from "../../redux/InwardIteraction/actions";
import XmlSection2 from "../XmlViewer/XmlViewer2";

const NameEnquiry = (props) => {
  const { goToMandateAdvice, getNameEnquiry, nameEnquiry, isLoading } = props;

  useEffect(() => {
    getNameEnquiry();
  },
  // eslint-disable-next-line
  [getNameEnquiry]);

  const request = nameEnquiry && nameEnquiry.request;
  const response = nameEnquiry && nameEnquiry.response;

  return (
    <div className="inward-xml-wrap">
      <div className="inward-xml-wrap-header">
        <span className="nip-home-interaction-env-left-circle">i</span>
        <div className="inward-xml-wrap-header-title">Name Enquiry</div>
        <div className="inward-xml-wrap-header-title2">
          Run tests, requests and responses, make API Calls and perform other
          related activities.
        </div>
      </div>
      <XmlSection2
        request={request}
        response={response}
        url={"api.nibss.com/transaction/initialize"}
        isLoading={isLoading}
      />
      <div className="retry-btn2">
        <button
          className="button-next2"
          type="button"
          onClick={goToMandateAdvice}
        >
          Next
        </button>
      </div>
    </div>
  );
};

NameEnquiry.propTypes = {
  getNameEnquiry: PropTypes.func,
  goToMandateAdvice: PropTypes.func,
  isLoading: PropTypes.bool,
  nameEnquiry: PropTypes.shape({
    request: PropTypes.string,
    response: PropTypes.string,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  getNameEnquiry: () => dispatch(getNameEnquiry()),
});

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isGettingNameEnquiry,
    getNameEnquirySuccess: state.inwardInteraction.getNameEnquirySuccess,
    nameEnquiry: state.inwardInteraction.nameEnquiry,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NameEnquiry);
